import _ from 'underscore';
import { FAC_FEATURE_ID } from '@bingads-webui-campaign/recommendation-core';

export const logApi = 'tips-card/index';
export const TipDismissalExpirationDays = 7;
export const numberOfTipsAndRecommendations = 9;
export const numberOfAccountRecommendations = 6;
export const numberOfCustomerRecommendations = 6;
export const numberOfCampaignRecommendations = 4;
export const numberOfTipsShown = 3;

// mapping of FeatureId to tipIds, sorted by priority
export const FAC_FEATUREID_TIPID_PRIORITY_MAPPING = {
  [FAC_FEATURE_ID.GOOGLE_IMPORT]: [
    1701,
    101,
  ],
  [FAC_FEATURE_ID.CONVERSION_TRACKING]: [
    801, // conversionTrackingVideo
  ],
};

// mapping of tipIds to FeatureId
export const FAC_TIPID_FEATUREID_MAPPING = _.reduce(
  FAC_FEATUREID_TIPID_PRIORITY_MAPPING,
  (mapping, priorities, featureId) =>
    _.extend(mapping, ..._.map(priorities, tipId => ({ [tipId]: featureId }))),
  {}
);

export const instrumentationSchema = {
  scenario: [
    {
      name: 'loadRecommendationOverviewTile',
      value: 'LoadRecommendationOverviewTile',
      setting: {},
      activity: [
        {
          name: 'loadRecommendationOverviewTile',
          value: 'LoadRecommendationOverviewTile',
        },
      ],
    },
  ],
};
